module.exports = __webpack_public_path__ + "9d9d6e7b7cdcd4fcb203ef7dbee95a80.png";